//--------------------------
// copy object elem w/o ref
//--------------------------
export default function copyObjectNoRef(obj) {
  return JSON.parse(JSON.stringify(obj));
}
